// extracted by mini-css-extract-plugin
export var breedtext = "BreedListingCard-module--breedtext--aeb90";
export var cardanchor = "BreedListingCard-module--cardanchor--1c6d7";
export var cardcontainer = "BreedListingCard-module--cardcontainer--f9f11";
export var carddetails = "BreedListingCard-module--carddetails--a574a";
export var carddetailscontainer = "BreedListingCard-module--carddetailscontainer--af08a";
export var cardimage = "BreedListingCard-module--cardimage--779d5";
export var cardimagewrapper = "BreedListingCard-module--cardimagewrapper--1c547";
export var nametext = "BreedListingCard-module--nametext--5368a";
export var sheddingdetails = "BreedListingCard-module--sheddingdetails--6cbb7 BreedListingCard-module--carddetails--a574a";